import { Button, Form, Icon } from 'react-bulma-components';
import { MODAL_TYPES, useGlobalModalContext } from "../hooks/globalModal";
import { Mention, MentionsInput } from 'react-mentions'
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { gql, useQuery } from '@apollo/client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScaleType } from '@tonaljs/tonal';
import _ from 'lodash';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';

const { Textarea } = Form;

const GET_SNIPPETS = gql`
  query GetSnippets {
    snippets{
      id
      text
    }
  }
`;

const MarkdownTextareaAC = forwardRef(({ name, placeholder, value, onChange, pageSlug }, ref) => {
  const { data, loading, error, refetch } = useQuery(GET_SNIPPETS);
  const [caretOffset, setCaretOffset] = useState(0);
  const [customSnippets, setCustomSnippets] = useState([]);
  useEffect(() => {
    if(data && data.snippets)
    {
      setCustomSnippets([...data.snippets]);
    }
  }, [data]);

  const handleOnChange = (newValue, newPlainTextValue, mentions) => {
    const event = new Event('input');
    let target = { value: newPlainTextValue, name: name };
    Object.defineProperty(event, 'target', { writable: false, value: target });

    onChange(event);

  }

  //pageSlug = "all";  // TODO remove
  const { showModal, hideModal } = useGlobalModalContext();
  let areaRef = useRef(null);
  useImperativeHandle(ref, () => ({
    getAreaRef() {
      return areaRef;
    }
  }));
  useEffect(() => {
    console.log("After render")
    const ta = areaRef.current;
    ta.selectionStart = ta.selectionEnd = ta.selectionStart + caretOffset;
    setCaretOffset(null);
  }, [caretOffset]);

/*   function onImagePropsFromModal({ path, bg }) {
    hideModal();
    const snippet = `<image src='${path}' bg='${bg === true ? 'o' : ''}'></image>`;
    pasteTemplate(null, snippet, snippet.length-8);
  } */
  const createModal = () => {
    showModal(MODAL_TYPES.MEDIA_MODAL, {
      title: `Files for /${pageSlug}`,
      path: `/${pageSlug}`,
      confirmBtn: "Save",
      //returnImageProps: onImagePropsFromModal,
      createModalFunction: createModal
    });
  };

  const componentSnippets = [
    { offset: 5, name: "abc", display: "<abc>", template: "<abc>\nK:C\n</abc>" },
    { offset: 2, name: "br", display: "<br />", template: "\n<br />\n" },
    { offset: 0, name: "ch", display: "<ch>", template: "<ch></ch>" },
    { offset: 0, name: "chord", display: "<chord>", template: "<chord></chord>" },
    { offset: 5, name: "image", display: "<image>", template: "<image src='' bg='w'></image>" },
    { offset: 5, name: "instrument", display: "<instrument>", template: "<instrument>\n <C></C>\n <Bb></Bb>\n <Eb></Eb>\n</instrument>\n" },
    { offset: 3, name: "key", display: "<key>", template: "<key i=''></key>" },
    { offset: 6, name: "go", display: "<go>", template: "<go to=''></go>" },
    { offset: 2, name: "group", display: "<group>", template: "<group>\n \n</group>" },
    { offset: 0, name: "notes", display: "<notes>", template: "<notes></notes>" },
    { offset: 9, name: "player", display: "<player>", template: "<player midiUrl=''/>" },
    { offset: 0, name: "sc", display: "<sc>", template: "<sc></sc>" },
    { offset: 0, name: "scale", display: "<scale>", template: "<scale></scale>" },
    { offset: 12, name: "score", display: "<score key>", template: "<score format='key' k=''>\n[\n</score>\n" },
    { offset: 10, name: "score", display: "<score text>", template: "<score format='text'>\n</score>\n" },
    { offset: 11, name: "score", display: "<score interval>", template: "<score format='interval'>\n[\n</score>\n" },
    { offset: 0, name: "t", display: "<t>", template: "<t></t>" },
  ]
  const queryComponents = (query, callback) => {
    if (query.length === 0) return componentSnippets.map(({ template, display }) => {
      return ({ id: template, display: display })
    })

    const matches = componentSnippets
      .filter((component) => {
        return component.name.startsWith(query.toLowerCase()) //indexOf(query.toLowerCase()) > -1
      })
      .slice(0, 10)
    return matches.map(({ template, display }) => {
      return ({ id: template, display: display })
    })
  }

/*   const customSnippets = [
    { name: "format='text'" },
    { name: "scale" },
    { name: "Good luck!" },
  ] */
  const queryCustom = (query, callback) => {
    if (query.length === 0) return customSnippets.map(({ text }) => {
      return ({ id: text, display: text })
    })

    const matches = customSnippets
      .filter((snippet) => {
        return snippet.text.toLowerCase().startsWith(query.toLowerCase()) //indexOf(query.toLowerCase()) > -1
      })
      .slice(0, 10)
    return matches.map(({ text }) => {
      return ({ id: text, display: text })
    })
  }

  const scaleNames = () => {
    return _.orderBy(_.flatten(ScaleType.all()
      .map(scaleType => {
        return scaleType.aliases.concat(scaleType.name)
      }
      )).map(scale => {
        return { name: scale }
      }), ['name'], ['asc']);
    //return [ {name: 'pentatonic'}, {name: 'pentatonic minor'}, {name: 'major'}, {name: 'minor'}]
  }
  const queryScales = (query, callback) => {
    if (query.length === 0) return scaleNames().map(({ name }) => {
      return ({ id: name, display: name })
    })

    const matches = scaleNames()
      .filter((scale) => {
        return scale.name.startsWith(query.toLowerCase()) //indexOf(query.toLowerCase()) > -1
      })
      .slice(0, 10)
    return matches.map(({ name }) => {
      return ({ id: name, display: name })
    })
  }
  const neverMatchingRegex = /($a)/

  /* eslint-disable import/no-anonymous-default-export */
  const mentionsInputStyle = {
    control: {
      backgroundColor: '#fff',
      fontSize: 16,
      // fontWeight: 'normal',
    },

    '&multiLine': {
      control: {
        fontFamily: 'monospace',
        minHeight: 60,
        lineHeight: 'normal'
      },
      highlighter: {
        padding: 9,
        border: '1px solid transparent',
      },
      input: {
        padding: 9,
        border: '1px solid silver',
      },
    },

    '&singleLine': {
      display: 'inline-block',
      width: 180,

      highlighter: {
        padding: 1,
        border: '2px inset transparent',
      },
      input: {
        padding: 1,
        border: '2px inset',
      },
    },

    suggestions: {
      list: {
        backgroundColor: 'white',
        border: '1px solid rgba(0,0,0,0.15)',
        fontSize: 16,
      },
      item: {
        padding: '5px 15px',
        borderBottom: '1px solid rgba(0,0,0,0.15)',
        '&focused': {
          backgroundColor: '#ffe6cc',
        },
      },
    },
  }

  return (
    <>
        <Button
          renderAs="span"
          marginless={true}
          onClick={() => createModal()}
          size='small'
        >
          <Icon><FontAwesomeIcon icon={faFolderOpen} /></Icon><b>Open files</b>
        </Button>
      <MentionsInput
        allowSpaceInQuery={true}
        inputRef={areaRef}
        name={name}
        style={mentionsInputStyle}
        value={value}
        onChange={handleOnChange}>
        {/* onChange={(event) => handleOnChange(event.target.value, name)}> */}
        <Mention
          onAdd={(id, display, startPos, endPos, offset) => {
            let emo = _.find(componentSnippets, { template: id });
            setCaretOffset(emo.offset);
          }}
          trigger="<"
          markup="__id__"
          // displayTransform={(id, display) => `<'${display}'`}
          regex={neverMatchingRegex}
          data={queryComponents}
          appendSpaceOnAdd={false}
        />
        <Mention
          trigger=":"
          markup="__id__"
          // displayTransform={(id, display) => `<'${display}'`}
          regex={neverMatchingRegex}
          data={queryScales}
          appendSpaceOnAdd={false}
        />
        <Mention
          trigger=";"
          markup="__id__"
          // displayTransform={(id, display) => `<'${display}'`}
          regex={neverMatchingRegex}
          data={queryCustom}
          appendSpaceOnAdd={false}
        />
      </MentionsInput>
    </>
  );
})

export default MarkdownTextareaAC;